import { motion } from "framer-motion";
import { Repeat2, Wrench, ShieldCheck, Truck, CreditCard, ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { openRequest } from "@/lib/api";

const Card = ({ className = "", children, delay = 0, testid }) => (
  <motion.div data-testid={testid} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={`group relative overflow-hidden rounded-[2rem] border border-fg/10 bg-[var(--ink-2)] p-7 transition-colors duration-500 hover:border-[var(--volt)]/40 ${className}`}>
    {children}
  </motion.div>
);

const ImgBg = ({ src }) => (
  <>
    <img src={src} alt="" className="absolute inset-0 h-full w-full object-cover opacity-60 transition-transform duration-[1.2s] group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#26282c] via-[#26282c]/60 to-transparent" />
  </>
);

const Cta = ({ service, label, testid }) => (
  <button data-testid={testid} onClick={() => openRequest(service)}
    className="mt-5 inline-flex items-center gap-2 rounded-full bg-fg/10 px-5 py-2.5 text-sm backdrop-blur transition-colors hover:bg-[var(--volt)] hover:text-[var(--ink)]">
    {label} <ArrowUpRight className="h-4 w-4" />
  </button>
);

export const Bento = () => (
  <section id="servizi" className="mx-auto max-w-7xl px-5 py-28 sm:px-8">
    <Reveal className="mb-14 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
      <div>
        <SectionLabel index="02">Servizi</SectionLabel>
        <h2 className="mt-5 max-w-2xl font-display text-4xl font-semibold leading-[0.95] tracking-tight sm:text-6xl">
          Non solo vendita. <span className="text-mist">Tutto il ciclo di vita del tuo telefono.</span>
        </h2>
      </div>
    </Reveal>
    <div className="grid auto-rows-[300px] grid-cols-1 gap-4 lg:grid-cols-12">
      <Card testid="bento-permuta" className="tone-dark flex flex-col justify-end lg:col-span-7 lg:row-span-2">
        <ImgBg src="/img/hero.jpg" />
        <div className="relative">
          <Repeat2 className="mb-4 h-8 w-8 text-[var(--volt)]" />
          <h3 className="font-display text-3xl font-semibold sm:text-5xl">Permuta l'usato</h3>
          <p className="mt-3 max-w-md text-fg2">Porta il tuo vecchio smartphone: lo valutiamo e il valore diventa uno sconto sul nuovo.</p>
          <Cta service="permuta" label="Richiedi una valutazione" testid="bento-permuta-cta" />
        </div>
      </Card>
      <Card testid="bento-riparazione" delay={0.1} className="tone-dark flex flex-col justify-end lg:col-span-5">
        <ImgBg src="/img/glow.jpg" />
        <div className="relative">
          <Wrench className="mb-3 h-6 w-6 text-[var(--volt)]" />
          <h3 className="font-display text-2xl font-semibold">Riparazioni</h3>
          <p className="mt-2 text-sm text-fg2">Schermo, batteria, connettori. Ti diamo un preventivo prima di toccare nulla.</p>
          <Cta service="riparazione" label="Prenota" testid="bento-riparazione-cta" />
        </div>
      </Card>
      <Card testid="bento-garanzia" delay={0.2} className="flex flex-col justify-between lg:col-span-5">
        <ShieldCheck className="h-6 w-6 text-[var(--volt)]" />
        <div>
          <p className="font-display text-7xl font-semibold leading-none text-fg">24<span className="text-[var(--volt)]">m</span></p>
          <h3 className="mt-3 font-display text-2xl">Garanzia su ogni prodotto</h3>
          <p className="mt-1 text-sm text-mist">E assistenza post-vendita, anche per la configurazione.</p>
        </div>
      </Card>
      <Card testid="bento-spedizione" delay={0.1} className="flex flex-col justify-between lg:col-span-4">
        <Truck className="h-6 w-6 text-[var(--volt)] transition-transform duration-700 group-hover:translate-x-24" />
        <div>
          <h3 className="font-display text-2xl font-semibold">Spedizione in tutta Italia</h3>
          <p className="mt-2 text-sm text-mist">Pacco assicurato e tracciato, dal nostro banco alla tua porta.</p>
        </div>
      </Card>
      <Card testid="bento-pagamenti" delay={0.2} className="flex flex-col justify-between bg-[var(--volt)] text-[var(--ink)] lg:col-span-8">
        <CreditCard className="h-6 w-6" />
        <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <h3 className="max-w-md font-display text-3xl font-semibold leading-tight sm:text-4xl">Paga con carta online, oppure chiedi prima un preventivo.</h3>
          <p className="max-w-[16rem] text-sm text-[var(--ink)]/80">Pagamenti protetti da Stripe. Nessun dato della carta passa dai nostri server.</p>
        </div>
      </Card>
    </div>
  </section>
);
